import get from 'lodash-es/get'
import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../../constants/common'
import { REG_EXP_EMAIL } from '../../../../constants/regExp'
import i18n from '../../../../i18n'
import {
  getFormikFormSelectFieldValidationSchema,
  getFormikFormSelectFieldWithCreationValidationSchema,
} from '../../../Formik'

import {
  REGISTRATION_FORM_FIELD_NAME_BUILDING,
  REGISTRATION_FORM_FIELD_NAME_EMAIL,
  REGISTRATION_FORM_FIELD_NAME_FIRST_NAME,
  REGISTRATION_FORM_FIELD_NAME_FLAT,
  REGISTRATION_FORM_FIELD_NAME_LAST_NAME,
  REGISTRATION_FORM_FLAT_MAX_LENGTH,
  REGISTRATION_FORM_SERVER_NON_FIELD_ERRORS,
} from './RegistrationForm.constants'

export function parseRegistrationFormServerError(error) {
  const errorText = get(error, ['response', 'data', 'errors'], EMPTY_STRING)

  if (REGISTRATION_FORM_SERVER_NON_FIELD_ERRORS[errorText]) {
    return i18n.t(REGISTRATION_FORM_SERVER_NON_FIELD_ERRORS[errorText])
  }

  return errorText
}

export function getRegistrationFormValidationSchema() {
  return Yup.object({
    [REGISTRATION_FORM_FIELD_NAME_BUILDING]:
      getFormikFormSelectFieldValidationSchema({
        notSelectedValueErrorText: i18n.t(
          'Error.RegistrationFormNotSelectedBuildingKey'
        ),
        required: true,
      }),
    [REGISTRATION_FORM_FIELD_NAME_EMAIL]: Yup.string()
      .matches(
        REG_EXP_EMAIL,
        i18n.t('Error.RegistrationFormInvalidEmailFormatKey')
      )
      .required(true),
    [REGISTRATION_FORM_FIELD_NAME_FIRST_NAME]: Yup.string().required(true),
    [REGISTRATION_FORM_FIELD_NAME_FLAT]:
      getFormikFormSelectFieldWithCreationValidationSchema({
        maxLength: REGISTRATION_FORM_FLAT_MAX_LENGTH,
        required: true,
      }),
    [REGISTRATION_FORM_FIELD_NAME_LAST_NAME]: Yup.string().required(true),
  })
}

export function getRegistrationFormPayload(values) {
  return {
    building: values[REGISTRATION_FORM_FIELD_NAME_BUILDING].value,
    email: values[REGISTRATION_FORM_FIELD_NAME_EMAIL],
    flat:
      values[REGISTRATION_FORM_FIELD_NAME_FLAT]?.number ??
      values[REGISTRATION_FORM_FIELD_NAME_FLAT],
    name: values[REGISTRATION_FORM_FIELD_NAME_FIRST_NAME],
    second_name: values[REGISTRATION_FORM_FIELD_NAME_LAST_NAME],
  }
}

export function getRegistrationFormCreateFlatPayload(values) {
  return {
    building: values[REGISTRATION_FORM_FIELD_NAME_BUILDING].value,
    number: values[REGISTRATION_FORM_FIELD_NAME_FLAT],
  }
}
